{
  "_meta": {
    "_comment": "Phase 14.1 Wave 8 Task 40 — merchant orders namespace (embroidery 2-step accept dialog). vg-binding: P14.1.D-04 / P14.1.D-18 / INTERFACE-STANDARDS:error-shape",
    "locale": "en"
  },
  "embAccept": {
    "title": "Embroidery fee awaiting approval",
    "titleWithOrder": "Embroidery fee awaiting approval — Order {{orderNumber}}",
    "subtitle": "Fee is computed from the actual stitch count in the digitize file.",
    "deadlineBadge": "{{remaining}} left",
    "deadlineTooltip": "If not accepted within 72 hours the order auto-cancels and is fully refunded.",
    "deadlineAt": "Respond by {{deadline}}",
    "colArtwork": "Artwork / side",
    "colPosition": "Position",
    "colStitches": "Stitches",
    "colFee": "Fee",
    "positionFirst": "First",
    "positionSubsequent": "Subsequent",
    "total": "Total embroidery fee",
    "acceptButton": "Accept embroidery fee {{amount}}",
    "accepting": "Processing…",
    "cancel": "Cancel",
    "autoCancelNote": "No response within 72 hours: the order auto-cancels and the full amount is refunded to your wallet. This action is idempotent (safe against duplicate submits).",
    "success": "Embroidery fee accepted.",
    "networkFallback": "Network error - check connection",
    "remaining": {
      "expired": "Deadline passed",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "minutes": "{{minutes}}m"
    },
    "errors": {
      "notPending": "This fee is no longer pending — the dialog will refresh.",
      "quoteMismatch": "The fee changed since it was loaded — review the updated breakdown.",
      "walletInsufficient": "Your wallet balance is insufficient — top up to accept this fee."
    }
  },
  "payBulk": {
    "resultPaidList": "Paid: {{list}}",
    "resultSkippedHeading": "Skipped ({{n}}) — these orders were not charged:",
    "toast": {
      "payBulkSummary": "{{paidCount}} paid, {{skippedCount}} skipped — {{totalDebited}} debited.",
      "payBulkInvalid": "Bulk payment could not be submitted. Check your selection and try again."
    },
    "reason": {
      "PRICE_CHANGED": "Price changed — request a new quote",
      "SHIPPING_CHANGED": "Shipping rate changed — request a new quote",
      "TAX_CHANGED": "Tax rate changed — request a new quote",
      "EXPIRED": "Quote expired — request a new quote",
      "CART_CHANGED": "Order contents changed — review the order, then request a new quote",
      "CONSUMED": "Already paid — this order was charged earlier",
      "MISSING_SNAPSHOT": "No valid quote on this order — request a new quote",
      "QUOTE_STALE": "Quote is out of date — request a new quote",
      "WALLET_INSUFFICIENT": "Not enough balance — top up and try again",
      "SHIPPING_UNAVAILABLE": "No shipping service covers this destination — open the order to change it",
      "PRICING_MISMATCH": "Pricing error — nothing was charged, please try again",
      "IDEMPOTENCY_KEY_REUSE": "This order changed since the batch started — reload and try again",
      "ORDER_FORBIDDEN": "You no longer have access to this order",
      "ORDER_NOT_FOUND": "Order no longer exists"
    }
  }
}
